module.exports = __webpack_public_path__ + "img/personalcenter1.b13be87c.png";